import {Component} from '@angular/core';

@Component({
  selector: 'yo-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent  {



  constructor() {
  }

}
